import Route from '@ember/routing/route';
// This is for types. Anything we have custom may show an error.
import type StoreService from 'ember-data/store';
import { service } from '@ember/service';
import type SessionContextService from 'tio-employee/services/session-context';
import type CompanyModel from 'tio-data/models/company';

export default class AuthenticatedAdminReportingTasProgramsRoute extends Route {
  @service declare store: StoreService;
  @service declare sessionContext: SessionContextService;

  // Layout configuration - declares this route needs full-width layout
  layoutType = 'full-width' as const;

  queryParams = {
    applicationStatus: { refreshModel: false },
    applicationCreatedAtStart: { refreshModel: false },
    coursesEndDate: { refreshModel: false },
    includeCourses: { refreshModel: false },
    includePayments: { refreshModel: false },
  };

  async model() {
    const id = this.sessionContext.currentRole?.company.id;

    return (
      // @ts-expect-error fix model
      this.store.peekRecord<CompanyModel>('company', id) ||
      // @ts-expect-error fix model
      (await this.store.findRecord<Company>('company', id, { include: 'company-setting' }))
    );
  }
}
